import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid="theme-toggle"
      aria-label="Toggle theme"
      className="flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground hover:text-foreground transition-all duration-[140ms]"
      style={{
        background: 'var(--border-subtle)',
        border: '1px solid var(--border-default)',
      }}
    >
      <span className="relative h-[14px] w-[14px]">
        <Sun
          className={`absolute inset-0 h-[14px] w-[14px] transition-all duration-300 ${theme === 'dark' ? 'opacity-100 rotate-0' : 'opacity-0 -rotate-90'}`}
          strokeWidth={2}
        />
        <Moon
          className={`absolute inset-0 h-[14px] w-[14px] transition-all duration-300 ${theme === 'dark' ? 'opacity-0 rotate-90' : 'opacity-100 rotate-0'}`}
          strokeWidth={2}
        />
      </span>
    </button>
  );
}
